/* eslint-disable no-nested-ternary */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import ReactRouterPropTypes from 'react-router-prop-types';
import PropTypes from 'prop-types';
import translations from '@nike/gameday-translations/web';

import DepartmentHeader from './DepartmentHeader';
import Department from './Department';
import { H1, NoResults, PageTitle, Spinner } from '../../components';
import SortOptions from '~COMPONENTS/sortOptions/SortOptions';
import SearchFilter from '~COMPONENTS/SearchFilter';
import GlobalToolTip from '~COMPONENTS/tooltips/GlobalToolTip';
import { TranslatedCopy } from '../../intl/TranslatedCopy';
import {
  clearProducts,
  clearSelectedFilters,
  fetchDepartmentsByAccountId,
  resetCursor,
  setSearchTerm
} from '../actions';
import { getSelectedDepartment } from '../selectors';
import { setUseCurrentContract } from '../../account/actions';
import { setSelectedDepartment } from '../../carts/actions';
import { currentCartCrd, forecastShopDepartments, useCurrentContract } from '../../account/reducer';
import {
  getGamedayAccount,
  getCurrentAllotments,
  getFutureAllotments,
  getIsGreaterChinaSalesOrg
} from '../../gamedayAccount/selectors';
import { fetchGamedayAccount } from '../../gamedayAccount/actions';
import { getPendingStatus } from '../../util/requestReducer';
import { setBillableSapAddress, setCompSapAddress, clearOneTimeAddress } from '../../checkout/actions';
import { searchTerm } from '../../global/reducer';
import { alwaysShowCart, getUserData, getUserAccount } from '../../user/selectors';

import { ZERO_DOLLAR_VALUE } from '../../util/constants';

import { newAllotmentTypes } from '../../types/allotments';
import { userTypes, userAccountTypes } from '../../types/user';
import { selectedDepartmentTypes } from '../../types/shop';
import { mapAllotmentDepts } from '../../util/mapAllotmentDepts';
import { getUserRole } from '../../util/languageTranslations';

const buildShopUrl = (acctNum, deptNum, deptType) => `/shop/${acctNum}/dept/${deptNum}/${deptType.toLowerCase()}`;

export class DepartmentSelect extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fullDeptList: [],
      departments: [],
      depCatas: {}
    };
  }

  componentDidMount() {
    const {
      alwaysShowCart,
      currentAllotments,
      currentCartCrd,
      futureAllotments,
      history,
      selectedDepartment,
      setSearchTerm,
      userAccount,
      userData
    } = this.props;

    if (!userAccount || !userData) {
      return history.push('/select-account');
    }

    if (alwaysShowCart && selectedDepartment && userAccount) {
      const { number, type } = selectedDepartment;
      const gridwallUrl = buildShopUrl(userAccount.number, number, type);
      history.push(gridwallUrl);
    }
    setSearchTerm({});
    this.initializeDepartments();

    if (currentCartCrd && currentAllotments?.contractStartDate) {
      this.setCurrentContract();
    }

    if (userData?.accounts && (currentAllotments.departments || futureAllotments.departments)) {
      this.setLists();
    }
    return true;
  }

  componentDidUpdate(prevProps) {
    const {
      alwaysShowCart,
      currentAllotments,
      currentCartCrd,
      history,
      selectedDepartment,
      userAccount,
      gamedayAccountNumber
    } = this.props;
    const userAccountChanged = prevProps.userAccount?.number !== userAccount?.number;
    const gamedayAccountChanged = prevProps.gamedayAccountNumber !== gamedayAccountNumber;

    if (gamedayAccountChanged || userAccountChanged) {
      this.setLists();
      this.setDepartmentCatalogData();
    }

    if (prevProps.currentCartCrd !== currentCartCrd && currentAllotments && currentAllotments.contractStartDate) {
      this.setCurrentContract();
    }

    if (alwaysShowCart && userAccount && !prevProps.selectedDepartment && selectedDepartment) {
      const { number, type } = selectedDepartment;
      const gridwallUrl = buildShopUrl(userAccount.number, number, type);
      history.push(gridwallUrl);
    }
  }

  setFullDeptList = fullDeptList => {
    const { en } = translations;

    const translatedFullDeptList = fullDeptList.map(i => {
      const manipulatedArrayItem = i;

      // eslint-disable-next-line no-unused-expressions
      getUserRole() && en[`shop.deptSelect.deptName.${i.number}`]
        ? (manipulatedArrayItem.name = `${i.name} 
        ${en[`shop.deptSelect.deptName.${i.number}`]}`)
        : manipulatedArrayItem;
      return manipulatedArrayItem;
    });
    return this.setState({ fullDeptList: translatedFullDeptList });
  };

  setDepartments = departments => this.setState({ departments });

  setCurrentContract = () => {
    const { currentAllotments, currentCartCrd, setUseCurrentContract } = this.props;

    const currentStartDate = Date.parse(currentAllotments.contractStartDate);
    const currentEndDate = Date.parse(currentAllotments.contractEndDate);
    const currentCrd = Date.parse(currentCartCrd);

    setUseCurrentContract(currentCrd <= currentEndDate && currentCrd >= currentStartDate);
  };

  setDepartmentCatalogData = async () => {
    const {
      fetchDepartmentsByAccountId,
      userAccount: { id }
    } = this.props;

    const depCatas = await fetchDepartmentsByAccountId(id);

    this.setState({
      depCatas: (depCatas || []).reduce(
        (acc, { hasAtOnceCatalogs, hasForecastCatalogs, hasFuturesCatalogs, number }) => ({
          ...acc,
          [number]: {
            hasAtOnceCatalogs,
            hasForecastCatalogs,
            hasFuturesCatalogs
          }
        }),
        {}
      )
    });
  };

  setLists = () => {
    const deptList = this.combineDepartmentLists();
    this.setDepartments(deptList);
    this.setFullDeptList(deptList);
  };

  combineDepartmentLists = () => {
    const { currentAllotments, futureAllotments } = this.props;
    const { depCatas } = this.state;
    const hasFutureAllotments = !!futureAllotments?.departments;
    const mappedCurrentDepts = mapAllotmentDepts(currentAllotments?.departments);
    const mappedFutureDepts = mapAllotmentDepts(futureAllotments?.departments);

    if (!mappedCurrentDepts && !mappedFutureDepts) {
      return false;
    }

    const allotmentObject = {};

    if (mappedCurrentDepts) {
      mappedCurrentDepts.forEach(dept => {
        allotmentObject[dept.departmentNumber] = {
          name: dept.departmentName,
          number: dept.departmentNumber,
          code: dept.currencyCode,
          currentRemaining: dept.remainingAllotment,
          futureRemaining: ZERO_DOLLAR_VALUE,
          currentBillable: dept.billable,
          futureBillable: false,
          purchaseOptions: dept.purchaseOptions,
          unitAllotments: dept.unitAllotments,
          ...depCatas[dept.departmentNumber]
        };
      });
    }

    if (mappedFutureDepts) {
      mappedFutureDepts.forEach(
        ({
          billable,
          currencyCode,
          departmentName,
          departmentNumber,
          purchaseOptions,
          remainingAllotment,
          unitAllotments
        }) => {
          // eslint-disable-next-line
          if (allotmentObject.hasOwnProperty(departmentNumber)) {
            allotmentObject[departmentNumber].futureRemaining = remainingAllotment;
            allotmentObject[departmentNumber].futureBillable = billable;
            allotmentObject[departmentNumber] = {
              ...allotmentObject[departmentNumber],
              ...depCatas[departmentNumber]
            };
          } else {
            allotmentObject[departmentNumber] = {
              name: departmentName,
              number: departmentNumber,
              code: currencyCode,
              currentRemaining: ZERO_DOLLAR_VALUE,
              futureRemaining: remainingAllotment,
              currentBillable: false,
              futureBillable: billable,
              isCurrent: false,
              purchaseOptions,
              unitAllotments,
              ...depCatas[departmentNumber]
            };
          }
        }
      );
    }

    /**
     * The map takes the departments and orders them.
     * Sorting with ascending or descencing but nulls get places always last.
     */
    return Object.values(allotmentObject).map(dept => {
      const { currentBillable, currentRemaining, futureBillable, futureRemaining } = dept;
      const noCurrentValue = currentRemaining ? currentRemaining === ZERO_DOLLAR_VALUE : true;
      const noFutureValue = currentRemaining ? futureRemaining === ZERO_DOLLAR_VALUE : true;
      /**
       * Setting these to null when there is no value and the departments cannot
       * be shopped at sorts them always last.
       */
      if (noCurrentValue && noFutureValue && !currentBillable && !futureBillable) {
        // eslint-disable-next-line no-param-reassign
        dept.currentRemaining = null;
        // eslint-disable-next-line no-param-reassign
        dept.futureRemaining = null;
      }

      // eslint-disable-next-line no-param-reassign
      dept.hasFutureAllotments = hasFutureAllotments;

      return dept;
    });
  };

  initializeDepartments = async () => {
    const {
      clearProducts,
      clearSelectedFilters,
      currentAllotments,
      futureAllotments,
      resetCursor,
      setBillableSapAddress,
      setCompSapAddress,
      clearOneTimeAddress
    } = this.props;
    const { departments } = this.state;

    await this.setDepartmentCatalogData();

    if ((currentAllotments?.departments || futureAllotments?.departments) && !departments.length) {
      this.setLists();
      clearSelectedFilters();
      clearProducts();
      setBillableSapAddress(null);
      setCompSapAddress(null);
      clearOneTimeAddress();
      resetCursor();
    }
  };

  handleSortOptionsChange = updatedList => this.setDepartments(updatedList);

  handleDepartmentClick = ({ number, type }) => {
    const { setSelectedDepartment } = this.props;
    setSelectedDepartment(number, type);
  };

  render() {
    const {
      currentAllotments,
      futureAllotments,
      searchTerm,
      userAccount,
      useCurrentContract,
      forecastShopDepartments,
      isFetching,
      isGreaterChinaSalesOrg
    } = this.props;
    const { departments, fullDeptList } = this.state;
    const hasDepartments = departments.length > 0;
    const currentContractPeriod = currentAllotments
      ? `${currentAllotments.contractStartDate} – ${currentAllotments.contractEndDate}`
      : null;

    let futureContractPeriod = null;
    if (useCurrentContract) {
      futureContractPeriod = currentContractPeriod;
    } else if (futureAllotments) {
      if (Object.keys(futureAllotments.departments || {}).length > 0) {
        futureContractPeriod = `${futureAllotments.contractStartDate} – ${futureAllotments.contractEndDate}`;
      } else {
        futureContractPeriod = new TranslatedCopy({ id: 'shop.deptSelect.noFutureAllotments' }).toString();
      }
    }

    return (
      <div className='departmentSelect bg-white'>
        <PageTitle title='shop.deptSelect.title' />
        <H1 className=' mb4-lg d-sm-h d-md-b'>
          <span className='flex-container row align-center'>
            <span className='departmentSelect__title'>
              <TranslatedCopy id='shop.deptSelect.title' />
            </span>
            <GlobalToolTip
              className='ml2-sm'
              content={new TranslatedCopy({ id: 'shop.deptSelect.title.tooltip' }).toString()}
            />
          </span>
        </H1>
        <div>
          <div className='flex-container row space-between u-full-width align-center'>
            <SearchFilter
              label={new TranslatedCopy({ id: 'shop.deptSelect.search.label' }).toString()}
              list={fullDeptList}
              filterBy={['name', 'number']}
              pageName='departmentSelect'
              setList={this.setDepartments}
            />
            <SortOptions
              list={departments}
              sortBy={[
                { value: 'name', name: 'shop.departmentSelect.search.department.title' },
                {
                  value: 'currentRemaining',
                  name: 'shop.departmentSelect.search.current.title',
                  isNumber: true
                },
                {
                  value: useCurrentContract ? 'currentRemaining' : 'futureRemaining',
                  name: 'shop.departmentSelect.search.future.title',
                  isNumber: true
                }
              ]}
              defaultValue={{ value: 'name', name: 'Department Name' }}
              handleSortOptionsChange={this.handleSortOptionsChange}
            />
            <div className='d-md-h'>
              <GlobalToolTip
                className='ml2-sm'
                content={new TranslatedCopy({ id: 'shop.deptSelect.title.tooltip' }).toString()}
              />
            </div>
          </div>
          {!hasDepartments &&
            !searchTerm &&
            (isFetching ? <Spinner /> : <NoResults titleId='shop.deptSelect.noData' />)}
          {!hasDepartments && searchTerm && <NoResults titleId='shop.deptSelect.search.noResults' />}
          {hasDepartments && (
            <div>
              <DepartmentHeader
                currentContractPeriod={currentContractPeriod}
                futureContractPeriod={futureContractPeriod}
              />
              {departments.map(dept => (
                <Department
                  key={`department-${dept.number}`}
                  accountNumber={userAccount.number}
                  department={dept}
                  onShopDeptClick={this.handleDepartmentClick}
                  useCurrentContract={useCurrentContract}
                  forecastShop={forecastShopDepartments.has(dept.number)}
                  isGreaterChinaSalesOrg={isGreaterChinaSalesOrg}
                />
              ))}
            </div>
          )}
        </div>
      </div>
    );
  }
}

DepartmentSelect.propTypes = {
  alwaysShowCart: PropTypes.bool.isRequired,
  clearProducts: PropTypes.func.isRequired,
  clearSelectedFilters: PropTypes.func.isRequired,
  gamedayAccountNumber: PropTypes.string.isRequired,
  currentAllotments: newAllotmentTypes,
  currentCartCrd: PropTypes.string,
  fetchDepartmentsByAccountId: PropTypes.func.isRequired,
  forecastShopDepartments: PropTypes.any,
  futureAllotments: newAllotmentTypes,
  history: ReactRouterPropTypes.history.isRequired,
  isFetching: PropTypes.bool,
  isGreaterChinaSalesOrg: PropTypes.bool.isRequired,
  resetCursor: PropTypes.func.isRequired,
  searchTerm: PropTypes.string,
  selectedDepartment: selectedDepartmentTypes,
  setSelectedDepartment: PropTypes.func.isRequired,
  setBillableSapAddress: PropTypes.func.isRequired,
  setCompSapAddress: PropTypes.func.isRequired,
  clearOneTimeAddress: PropTypes.func.isRequired,
  setSearchTerm: PropTypes.func.isRequired,
  setUseCurrentContract: PropTypes.func.isRequired,
  useCurrentContract: PropTypes.bool.isRequired,
  userAccount: userAccountTypes,
  userData: userTypes
};

DepartmentSelect.defaultProps = {
  currentAllotments: null,
  currentCartCrd: null,
  forecastShopDepartments: [],
  futureAllotments: null,
  isFetching: null,
  searchTerm: null,
  selectedDepartment: null,
  userAccount: null,
  userData: null
};

const mapStateToProps = state => ({
  alwaysShowCart: alwaysShowCart(state),
  gamedayAccountNumber: getGamedayAccount(state).accountNumber,
  currentAllotments: getCurrentAllotments(state),
  futureAllotments: getFutureAllotments(state),
  currentCartCrd: currentCartCrd(state),
  forecastShopDepartments: forecastShopDepartments(state),
  searchTerm: searchTerm(state),
  selectedDepartment: getSelectedDepartment(state),
  useCurrentContract: useCurrentContract(state),
  userAccount: getUserAccount(state),
  userData: getUserData(state),
  isFetching: getPendingStatus(state, fetchGamedayAccount.event.name),
  isGreaterChinaSalesOrg: getIsGreaterChinaSalesOrg(state)
});

const connector = connect(mapStateToProps, {
  clearProducts,
  clearSelectedFilters,
  resetCursor,
  fetchDepartmentsByAccountId,
  setSelectedDepartment,
  setBillableSapAddress,
  setCompSapAddress,
  clearOneTimeAddress,
  setSearchTerm,
  setUseCurrentContract
});

export default connector(DepartmentSelect);
